import { render, staticRenderFns } from "./MessageDashboard.vue?vue&type=template&id=850579da&scoped=true&"
import script from "./MessageDashboard.vue?vue&type=script&lang=js&"
export * from "./MessageDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MessageDashboard.vue?vue&type=style&index=0&id=850579da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850579da",
  null
  
)

export default component.exports